import { Layout } from "antd";
import { Outlet } from "react-router-dom";

export default function PublicLayout() {
  return (
    <Layout>
      <Layout.Content>
        <Outlet />
      </Layout.Content>
    </Layout>
  );
}
